import { createContext, ReactNode, useContext } from 'react';
import { BusinessLine } from '../../types/definitions/vendor/graphql-schema.d';
interface ClientContext {
  clientBusinessLine: BusinessLine | undefined;
  firstName: string;
  isAuthenticatedClient: boolean;
}
interface ClientContextProps {
  children: ReactNode;
  clientBusinessLine: BusinessLine | undefined;
  firstName?: string | undefined;
  isAuthenticatedClient?: boolean | undefined;
}
const ClientContext = createContext<ClientContext>({
  clientBusinessLine: undefined,
  firstName: '',
  isAuthenticatedClient: true
});
export const useClientContext = () => useContext(ClientContext);
export const ClientContextProvider = ({
  children,
  clientBusinessLine,
  firstName = '',
  isAuthenticatedClient = true
}: ClientContextProps) => {
  return <ClientContext.Provider value={{
    clientBusinessLine,
    firstName,
    isAuthenticatedClient
  }}>
      {children}
    </ClientContext.Provider>;
};